import z from "zod";

import {
  BookingSchema,
  EventSchema,
  EventSessionSchema,
  LocationSchema,
  OrgSchema,
  TicketSchema,
  TicketTierSchema,
  UserSchema
} from "../models/generated";
import { PageReqSchema } from "./base";

export const TicketQuerySchema = PageReqSchema.extend({
  eventId: z.string().optional(),
  bookingId: z.string().optional()
});
export type TicketQuery = z.infer<typeof TicketQuerySchema>;

export const CheckInTicketSchema = z.object({
  ticketId: z.string().uuid()
});
export type CheckInTicket = z.infer<typeof CheckInTicketSchema>;

export const TicketDetailSchema = TicketSchema.extend({
  booking: BookingSchema.extend({
    user: UserSchema
  }),
  ticketTier: TicketTierSchema.extend({
    eventSession: EventSessionSchema.extend({
      event: EventSchema.extend({
        host: OrgSchema,
        location: LocationSchema
      })
    })
  })
});
export type TicketDetail = z.infer<typeof TicketDetailSchema>;
